// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"29ab4679","507":"94314fb1","787":"cda612ba","878":"02597e24","892":"080d91d3","948":"fc4f62db"}[chunkId] + ".chunk.js";
};